import { render } from "./3DViewerProfilePage.vue?vue&type=template&id=44e305fc&ts=true"
import script from "./3DViewerProfilePage.vue?vue&type=script&lang=ts"
export * from "./3DViewerProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__